import {
    useMutation,
    useQueryClient
} from '@tanstack/react-query'
import { useMethods } from '@shared/hooks/methods'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import 'yup-phone'
import axios from '@shared/utils/axios'
import mapServerErrors from '@shared/utils/mapErrors'
import { useForm } from 'react-hook-form'

const schema = yup.object({
    business: yup.string().required('اكتب اسم الشركة').max(100, 'الإسم طويل، الحد ١٠٠ حرف'),
    name: yup.string().required('اكتب الإسم').max(150, 'الاسم طويل، الحد ١٥٠ حرف'),
    email: yup.string().required('اكتب البريد').email('صيغة البريد خاطئة'),
    phone_number: yup
        .string()
        .max(13, 'الرقم طويل، الحد هو ١٢ خانة')
        .matches(
            /^\+\d{1,3}\d{9}$/,
            {
                message: 'الرقم خاطئ',
                excludeEmptyString: true
            }
        ),
    password: yup.string().required('اكتب كلمة المرور')
})

export const useSignupForm = () => {
    const form = useForm({
        resolver: yupResolver(schema),
        defaultValues: {}
    })
    const queryClient = useQueryClient()
    const { showMessage } = useMethods()
    const { mutate } = useMutation({
        onMutate: () => {
            showMessage({
                text: 'جارٍ الإنشاء...',
                loading: true
            })
        },
        mutationFn: async (variables) => {
            const request = await axios.post('auth/signup', variables)
            return request.data
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user'] })
            showMessage(null)
        },
        onError: (e) => {
            showMessage(null)
            mapServerErrors(e, form.setError, showMessage, form.getValues)
        }
    })

    return {
        form,
        mutate
    }
}
